export default "__VITE_ASSET__xqSV6dTU__"